import { FC, ReactNode } from 'react';
import ShowMoreText from '../libs/react-show-more-text/ShowMoreText';

type Props = {
  children: ReactNode;
  showMore?: ReactNode;
  showLess?: ReactNode;
  showLines: number;
  isExtendedFunction?: boolean;
  handlerShowLessClick?: (isExpanded: boolean) => void;
  width?: number;
  customClassName?: string;
};

const ShowMore: FC<Props> = ({
  isExtendedFunction,
  handlerShowLessClick,
  showLines,
  children,
  showMore,
  showLess,
  width,
  customClassName
}) => {
  const handlerOnClick = (isExpanded) => {
    handlerShowLessClick(isExpanded);
  };

  return (
    <div className="text-tundora pt-1 fs-caption-reg relative customShowMore">
      <ShowMoreText
        lines={showLines}
        more={showMore}
        less={showLess}
        width={width}
        className={customClassName}
        onClick={isExtendedFunction && handlerOnClick}
      >
        {children}
      </ShowMoreText>
    </div>
  );
};

export default ShowMore;
